<template>
  <div>
    <div id="Chart2" style="width: 100%; height: 250px"></div>
  </div>
</template>

<script>
export default {
  props:{
    chart2_data_x:{
      type:Array,
      default(){
        return []
      }
    },
    chart2_data_y:{
      type:Array,
      default(){
        return []
      }
    },
  },
  data() {
    return {

    };
  },
  methods: {
    myEcharts2() {
      var myChart2 = this.$echarts.init(document.getElementById("Chart2"));
      //配置图表
      var option2 = {
        title: {
          show: false,
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 35,
          top: 20,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            if(params[0].value > 0){
              return `${params[0].axisValue}<br />净流入金额: ${params[0].value}`
            }else {
              return `${params[0].axisValue}<br />净流出金额: ${params[0].value}`
            }
          },
          
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        xAxis: {
          data: this.chart2_data_x,
          silent: true,
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          axisLabel: {
            interval: 8,
            formatter: function (value) {
              //value 为 data的每一项
              //这里会循环 data  return出的每一项会替换渲染对应的data
              return `{a|${value}}`;
            },
            rich: {
              //富文本样式设置
              a: {
                color: "#666",
              },
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#f7f7f7",
            },
          },
          offset: 25,
        },
        yAxis: {
          type: "value",

          splitArea: {
            show: false,
          },
          axisTick: {
            show: false,
            
          },
        },
        series: [
          {
            type: "bar",
            data: this.chart2_data_y,
            large: true,
            barWidth: 12,
          },
        ],
      };
      myChart2.setOption(option2);
    },
  },
  mounted() {

  },
};
</script>

<style scoped>
</style>